import { NgModule } from '@angular/core';

import { MaterialModule } from '../../modules/material.module';
import { SharedModule } from '../../modules/shared.module';
import { IconButtonComponent } from './icon-button.component';

@NgModule({
  imports: [
    SharedModule,
    MaterialModule
  ],
  declarations: [
    IconButtonComponent
  ],
  exports: [
    IconButtonComponent
  ]
})
export class IconButtonModule {}
